import service from '@/utils/server';

const modName='/bd/purchOrderSwitch/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//查询可选采购单号
export const getOptionalPurchOrderNo = data => {
  return service({
    url: modName + 'getOptionalPurchOrderNo',
    method: 'post',
    data
  });
};

//订单切换添加
export const savePurchOrderSwitch = data => {
  return service({
    url: modName + 'savePurchOrderSwitch',
    method: 'post',
    data
  });
};

//订单切换修改
export const editPurchOrderSwitch = data => {
  return service({
    url: modName + 'editPurchOrderSwitch',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/bd/order/purchOrderSwitch/api/index.js